/**
 * The unsigned integer field type
 *
 * @group ISOBMFF
 *
 * @beta
 */
export const UINT = 'uint';
